import { c as _c } from "react/compiler-runtime";
import type { Entry } from 'contentful';
import type { PageProps } from '@libs/core';
import { buildPage } from '../../utils';
import { applyHomepageCampaignHeroH1 } from './apply-homepage-campaign-hero-h1';
import { OptexHomepageBiaGuest } from './components/optex-homepage-bia-guest';
export default function HomePage(t0) {
  const $ = _c(5);
  const {
    entry
  } = t0;
  const items = entry?.fields?.items as Entry[] | undefined;
  if (items) {
    applyHomepageCampaignHeroH1(items);
  }
  const t1 = items as Entry[];
  let t2;
  if ($[0] !== t1) {
    t2 = buildPage(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OptexHomepageBiaGuest />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <>{t2}{t3}</>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}